import axios from 'axios';
import { store } from '../store';
import config from '../config/index';

const ReviewService = {
  async getG2Token(visitor) {
    const { loginReducer } = store.getState();
    const { token } = loginReducer;

    try {
      const {
        data: { data },
      } = await axios.get(`${config.apiUrl}/g2/token`, {
        data: visitor,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (e) {
      return null;
    }
  },
};

export default ReviewService;
